

export const customTableStylesForSummery = {
    rows: {
        style: {
            minHeight: '50px', // override the row height
        }
    },
    headCells: {
        style: {
            background: '#3f3966',
            color: '#fff',
        },
    },
    cells: {
        style: {
            color: '#000',
            lineHeight: '22px',
            textAlign:'center'
        },
    },
};

// ── Modern table theme — a quiet, light "incident list" look: white rows,
// hairline dividers, muted uppercase headers, and color spent only where it
// carries real meaning (severity/error signals). Shared by the AI Bot Usage
// and Errors tabs so both read as one consistent surface.
export const modernPalette = {
    text: '#16121F',
    textMuted: '#716C82',
    textFaint: '#A29DB0',
    border: '#ECEBF2',
    hoverBg: '#FAFAFD',
    headBg: '#FBFBFD',
    signal: '#DC362B',
    signalBg: '#FCEBEA',
    tagBg: '#F1F0F6',
    tagText: '#5B5770',
    live: '#1CA463',
    liveBg: '#E7F8EF',
};

export const modernTableStyles = {
    table: {
        style: { backgroundColor: '#fff' },
    },
    headRow: {
        style: {
            backgroundColor: '#3f3966',
            borderBottom: `1px solid ${modernPalette.border}`,
            minHeight: '40px',
        },
    },
    headCells: {
        style: {
            color: '#fff',
            fontSize: '11px',
            fontWeight: 700,
            letterSpacing: '0.05em',
            textTransform: 'uppercase',
        },
    },
    rows: {
        style: {
            minHeight: '58px',
            borderBottom: `1px solid ${modernPalette.border}`,
            '&:last-of-type': { borderBottom: 'none' },
        },
        highlightOnHoverStyle: {
            backgroundColor: modernPalette.hoverBg,
            transitionDuration: '0.1s',
            outline: 'none',
        },
    },
    cells: {
        style: {
            paddingTop: '10px',
            paddingBottom: '10px',
        },
    },
    pagination: {
        style: {
            borderTop: `1px solid ${modernPalette.border}`,
            color: modernPalette.textMuted,
            fontSize: '12.5px',
        },
    },
};

// Wraps a DataTable in the same white/rounded/hairline card used by both tabs.
export const modernCardStyle = {
    background: '#fff',
    border: `1px solid ${modernPalette.border}`,
    borderRadius: '12px',
    boxShadow: '0 1px 3px rgba(20,16,30,0.05)',
    overflow: 'hidden',
};
